<content class="eidos-matrix">
  <ng-container [ngSwitch]="layout">
    <ng-container *ngSwitchCase="'row'" [ngTemplateOutlet]="rowLayout"></ng-container>
    <ng-container *ngSwitchCase="'tab'" [ngTemplateOutlet]="tabLayout"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="tabLayout"></ng-container>
  </ng-container>


  <ng-template #tabLayout>
    <dx-sortable
      filter=".dx-tab"
      [data]="activeConfig.sheets"
      itemOrientation="horizontal"
      dragDirection="horizontal"
      (onDragStart)="onTabDragStart($event)"
      (onReorder)="onTabDrop($event)">

      <dx-tab-panel
        [dataSource]="activeConfig.sheets"
        itemTitleTemplate="sheetName"
        itemTemplate="sheetData"
        [deferRendering]="false"
        [showNavButtons]="true"
        [repaintChangesOnly]="true"
        [(selectedIndex)]="activeSheet"
        [height]="activeConfig.size.height"
        [width]="activeConfig.size.width">

        <div *dxTemplate="let sheet of 'sheetName'">
          <dx-load-indicator [visible]="sheet.onExecutingTask">
          </dx-load-indicator>
          <span>
            {{ sheet.name }}
          </span>
        </div>

        <div *dxTemplate="let sheet of 'sheetData'">
          <ng-container
            [ngTemplateOutlet]="sheetTemplate"
            [ngTemplateOutletContext]="{sheet:sheet}">
          </ng-container>
        </div>

      </dx-tab-panel>
    </dx-sortable>
  </ng-template>

  <ng-template #rowLayout>
    <div *ngFor="let sheet of activeConfig.sheets" [ngStyle]="{height:sheet.size.height,display:sheet.isVisible() ? 'block' : 'none'}">
      <h1>
        {{ sheet.name }}
        <dx-load-indicator [(visible)]="sheet.onExecutingTask">
        </dx-load-indicator>
      </h1>
      <ng-container
        [ngTemplateOutlet]="sheetTemplate"
        [ngTemplateOutletContext]="{sheet:sheet}">
      </ng-container>
      <hr />
    </div>
  </ng-template>

  <ng-template #sheetTemplate let-sheet="sheet">
    <dx-data-grid #matrixSheet
      id="gridContainer{{sheet.id}}"
      [dataSource]="activeData[sheet.position]"
      [keyExpr]="sheet.rowKey"
      [showBorders]="true"
      [paging]="{enabled:false}"
      [classList]="'h-100'"
      [height]="sheet.size.height"
      [width]="sheet.size.width"
      [sorting]="{mode : 'none'}"
      [rowAlternationEnabled]="sheet.rowAlternationEnabled"
      [customizeColumns]="sheet.customizeColumns"
      [allowColumnResizing]="true"
      (onContentReady)="initChildRow()"
      (onEditingStart)="sheet.onEditStart($event, sheet)"
      (onCellPrepared)="sheet.onCellPrepared($event, sheet)"
      (onRowPrepared)="sheet.onRowPrepared($event, sheet)">

      <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
      <dxo-scrolling
        useNative="false"
        mode="standard"
        columnRenderingMode="strandard"
        scrollByThumb="true"
        showScrollbar="always">
      </dxo-scrolling>

      <dxo-editing
        mode="cell"
        [allowUpdating]="isUpdateCellAllowed"
        (changesChange)="onCellChanges($event,sheet,api)">
      </dxo-editing>

      <dxo-toolbar *ngIf="sheet.hasToolbar()">
        <dxi-item *ngIf="sheet.canAddRow" location="center">
          <dx-button icon="fas fa-table" (onClick)="addRow(sheet)">
          </dx-button>
        </dxi-item>
        <dxi-item *ngIf="sheet.canAddColumn" location="center">
          <dx-button icon="fas fa-columns" (onClick)="addColumn(sheet)">
          </dx-button>
        </dxi-item>
        <dxi-item *ngIf="sheet.customActions?.length > 0" location="center">
          <dx-button *ngFor="let action of sheet.customActions"
            stylingMode="outlined"
            [text]="action"
            (onClick)="execAction(action, sheet)">
          </dx-button>
        </dxi-item>
      </dxo-toolbar>

      <div *dxTemplate="let cellInfo of 'matrixCollasableGroupTemplate'" style="display: flex;justify-content: space-between;">
        <ng-container *ngIf="sheet.collapsed[cellInfo.column.index]; else noCollapsed">
          <span style="overflow: hidden;">{{cellInfo.column.caption}}</span>
          <i class="fas fa-ellipsis-h"
            style="margin: 0 4px;"
            [tooltipDrawer]="cellInfo.column.caption" trigger="hover"
          ></i>
          <i class="fas fa-expand-alt"
            style="cursor: pointer;"
            (click)="collapse($event,cellInfo.column,sheet,api,false)"
          ></i>
        </ng-container>

        <ng-template #noCollapsed>
          <span style="overflow: hidden; margin-right: 5px;">{{cellInfo.column.caption}}</span>
          <i class="fas fa-compress-alt"
            style="cursor: pointer;"
            (click)="collapse($event,cellInfo.column,sheet,api,true)"
          ></i>
        </ng-template>

      </div>

      <div *dxTemplate="let cellInfo of 'matrixBooleanTemplate'">
        <dx-switch [value]="cellInfo.value"></dx-switch>
      </div>
      <div *dxTemplate="let cellInfo of 'matrixBooleanTemplateEdit'">
        <dx-switch [value]="cellInfo.value"
          (onValueChanged)="cellInfo.setValue($event.value)">
        </dx-switch>
      </div>

      <div *dxTemplate="let cellInfo of 'matrixCommandTemplate'">
        <div *ngIf="sheet.hasChild(cellInfo.data)" [attr.title]="sheet.customizeCommandColumn.masterDetailsTooltip?.text || sheet.customizeCommandColumn.masterDetailsTooltip?.htmlText || null">
          <i class="fas"
            [ngClass]="sheet.customizeCommandColumn.closeDetailsIcon ?? 'fa-caret-right'"
            (click)="toogleChildRow($event,cellInfo,sheet,api)">
          </i>
          <span class="ms-1">{{sheet.customizeCommandColumn.masterDetailsText ?? ''}}</span>
        </div>
        <div *ngIf="sheet.isChildRow(cellInfo.data)" class="eidos-matrix-command-detail">
          <i class="fas"
            [ngClass]="sheet.customizeCommandColumn.detailsIcon ?? sheet.customizeCommandColumn.closeDetailsIcon ?? 'fa-caret-right'"
            [style.visibility]="sheet.customizeCommandColumn.detailsIcon ? 'visible' : 'hidden'">
          </i>
          <span class="ms-1">{{sheet.customizeCommandColumn.detailsText ?? ''}}</span>
        </div>
      </div>

      <div *dxTemplate="let cellInfo of 'matrixButtonTemplate'">
        <ng-container [ngTemplateOutlet]="callbackButtonTemplate"
            [ngTemplateOutletContext]="{config: sheet.getButtonCallback(cellInfo),info: cellInfo,sheet: sheet,api: api}">
        </ng-container>
      </div>

      <div *dxTemplate="let cellInfo of 'matrixActionMenuTemplate'" class="eidos-matrix-action-menu-cell">
        <lba-action-menu
          *ngIf="hasVisibleActionMenuItems(cellInfo, sheet)"
          [items]="getActionMenuItems(cellInfo, sheet)"
          [panelWidth]="240"
          (actionSelect)="onActionMenuSelect($event, cellInfo, sheet, api)">
          <span class="eidos-button eidos-button-normal eidos-button-success light-blue-button">Actions</span>
        </lba-action-menu>
      </div>

      <div *dxTemplate="let cellInfo of 'matrixNumberTemplateEdit'">
        <dx-number-box
          [(value)]="cellInfo.value"
          (onFocusIn)="focusIn($event)"
          (onValueChanged)="cellInfo.setValue($event.value)">
        </dx-number-box>
      </div>

      <div *dxTemplate="let cellInfo of 'matrixNumberTemplate'">
        <i *ngIf="showUndoManualValue(cellInfo)"
           class="fas fa-undo fa-sm"
           style="float: left; position: relative; z-index: 100; color: #800; cursor: pointer;"
           tooltipDrawer="undo manual changes" trigger="hover"
           (click)="resetStatus(cellInfo,sheet,api)"
        ></i>
        {{displayCustomFormattedValue.bind(this)(cellInfo,sheet)}}
      </div>
    </dx-data-grid>

    <dx-toolbar class="mt-3" *ngIf="sheet.hasBottomToolbar">
      <ng-container *ngFor="let action of sheet.customBottomActions">
        <dxi-item location="center" *ngIf="action.visible()">
          <dx-button
            [stylingMode]="action.buttonStylingMode ?? 'contained'"
            [type]="action.buttonType ?? 'success'"
            [text]="action.text ?? action.id"
            (onClick)="execAction(action.id, sheet)">
          </dx-button>
        </dxi-item>
      </ng-container>
    </dx-toolbar>
  </ng-template>
</content>

<ng-template #callbackButtonTemplate let-btn="config" let-info="info" let-sheet="sheet" let-api="api">
  <button *ngIf="btn?.visible(info,sheet)"
    type="button"
    class="eidos-button eidos-button-normal eidos-button-success"
    [ngClass]="getCallbackButtonClass(btn, info, sheet)"
    [disabled]="btn.disabled(info,sheet)"
    (click)="btn.callback(info,sheet,api)" [title]="getCallbackButtonTitle(btn, info, sheet)">
    {{ getCallbackButtonText(btn, info, sheet) }}
  </button>
</ng-template>

